export default __webpack_public_path__ + "static/Grosvenor_blue-cbc59f7fe99ef893f342ac5dd884bc51.png";